<template>
  <div id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">

        <div class="layui-form xblock">
          <button class="layui-btn xblock-row" v-on:click="ConfirmHint(1)"><i class="fa fa-anchor"></i> 同步订单</button>
          <button class="layui-btn layui-btn-normal xblock-row" v-on:click="InfoSyn('all')"><i class="fa fa-refresh"></i> 加载投入</button>
          <!-- <div class="layui-input-inline country_select xblock-row">
            <select name="status" v-model="current_status" lay-verify="required" lay-filter="status_selection">
              <option value="0">全部</option>
              <option :value="item.id" v-text="item.cn" v-for="(item,index) in status_list" v-bind:key="index"></option>
            </select>
          </div> -->
          <div class="layui-input-inline country_select xblock-row">
            <select name="shop" v-model="current_shop" lay-verify="required" lay-filter="shops_selection">
              <option value="0">全部</option>
              <option :value="item.id" v-text="item.name+' - '+item.country" v-for="(item,index) in shop_list"
                v-bind:key="index"></option>
            </select>
          </div>
          <div class="layui-input-inline country_select xblock-row">
            <select name="country" v-model="current_country" lay-verify="required" lay-filter="country_selection">
              <option value="0">全部</option>
              <option :value="item.id" v-text="item.name" v-for="item in country"></option>
            </select>
          </div>
          <div class="layui-input-inline xblock-row">
            <input type="text" class="layui-input" id="order_date" placeholder=" - " autocomplete="off" />
          </div>
          <div class="layui-input-inline xblock-row">
            <input type="text" name="username" placeholder="订单编号查询" v-on:keydown.13="get_order_list(true)" v-model="order_id"
              autocomplete="off" class="layui-input" />
          </div>
          <button class="layui-btn xblock-row" style="height: 36px;" lay-filter="sreach" v-on:click="get_order_list(true)"><i
              class="fa fa-search"></i></button>
          <span class="x-right xblock-row" style="line-height:40px" v-text="'共有数据：'+count+ '条'"></span>
          <div class="clear-both"></div>
		</div>

        <div class="layui-form total-data">
        	<div class="layui-input-inline total-data-row">
        		营业额：<i v-text="total_amount"></i>
        	</div>
        	<div class="layui-input-inline total-data-row">
        		总投入：<i v-text="actual_invested"></i>
        	</div>
        	<div class="layui-input-inline total-data-row">
        		总收入：<i v-text="escrow_amount"></i>
        	</div>
        	<div class="layui-input-inline total-data-row">
        		总利润：<i v-text="profit"></i>
        	</div>
        	<div class="layui-input-inline total-data-row">
        		利润率：<i v-text="profit_margin + '%'"></i>
        	</div>
        </div>

        <table class="layui-table layui-form boxlist">
          <thead>
            <tr>
              <th>
                <input type="checkbox" class="cxall" lay-filter="cxall" name="cxall" lay-skin="primary">
              </th>
              <th>站点</th>
              <th>状态</th>
              <th style="width: 140px;">订单编号</th>
              <th>商品数量</th>
              <th>总投入</th>
              <th>订单入账</th>
              <th>订单入账(RMB)</th>
              <th>利润</th>
              <th>利润率(%)</th>
              <th>日期</th>
              <th style="width: 145px;">操作</th>
            </tr>
          </thead>
          <tbody id="order_list" v-for="(item,index) in list" v-bind:key="index">
              <tr class="order_box" :class="[{cancel_box:item.order_status == 'CANCELLED'},{pending_box:item.order_status == 'READY_TO_SHIP'},{shipping_box:item.order_status == 'SHIPPED'}]">
                <td class="cx-box NoSelect" :data-ix="index">
                  <div><input type="checkbox" lay-filter="cx" lay-skin="primary" :data-index="index" :checked="item.active"></div>
                </td>
                <td class="Unfold" :data-ix="index">
              		<i v-if="item.country == 'TW'">台湾</i>
              		<i v-else-if="item.country == 'PH'">菲律宾</i>
              		<i v-else-if="item.country == 'VN'">越南</i>
              		<i v-else-if="item.country == 'TH'">泰国</i>
              		<i v-else-if="item.country == 'ID'">印尼</i>
              		<i v-else-if="item.country == 'SG'">新加坡</i>
              		<i v-else-if="item.country == 'BR'">巴西</i>
              		<i v-else-if="item.country == 'MX'">墨西哥</i>
              	</td>
              	<td>
              		<i v-if="item.order_status == 'UNPAID'">待付款</i>
              		<i v-else-if="item.order_status == 'READY_TO_SHIP'">待处理</i>
              		<i v-else-if="item.order_status == 'PROCESSED'">待出货</i>
              		<i v-else-if="item.order_status == 'SHIPPED'">运输中</i>
              		<i v-else-if="item.order_status == 'TO_CONFIRM_RECEIVE'">待完成</i>
              		<i v-else-if="item.order_status == 'IN_CANCEL'">待取消</i>
              		<i v-else-if="item.order_status == 'CANCELLED'">已取消</i>
              		<i v-else-if="item.order_status == 'COMPLETED'">已完成</i>
              		<i v-else>未知</i>
              	</td>
              	<td v-text="item.id"></td>
              	<td v-text="item.order_datas.items.length">2</td>
              	<td v-text="item.pay_money"></td>
              	<td>
              		<div v-if="item.order_datas.escrow_amount">
              			<i v-if="item.country == 'TW'" v-text="'NT'+item.order_datas.escrow_amount"></i>
              			<i v-else-if="item.country == 'PH'" v-text="'₱'+item.order_datas.escrow_amount"></i>
              			<i v-else-if="item.country == 'VN'" v-text="'₫'+item.order_datas.escrow_amount"></i>
              			<i v-else-if="item.country == 'TH'" v-text="'฿'+item.order_datas.escrow_amount"></i>
              			<i v-else-if="item.country == 'ID'" v-text="'Rp'+item.order_datas.escrow_amount"></i>
              			<i v-else-if="item.country == 'SG'" v-text="'$'+item.order_datas.escrow_amount"></i>
              			<i v-else-if="item.country == 'BR'" v-text="'R$'+item.order_datas.escrow_amount"></i>
              			<i v-else-if="item.country == 'MX'" v-text="'MX$'+item.order_datas.escrow_amount"></i>
              		</div>
              	</td>
              	<td v-text="item.cn_credit"></td>
              	<td class="major">
              		<i style="color: #099641;" v-if="item.order_status == 'CANCELLED' && item.order_datas.actual_shipping_cost > 0" v-text="'-'+item.order_datas.actual_shipping_cost"></i>
              		<i v-else v-text="item.profit"></i>
              	</td>
              	<td>
                  <i v-if="item.profit_margin" v-text="item.profit_margin+'%'"></i>
                </td>
              	<td v-text="item.create_time"></td>
              	<td class="btn-arr NoSelect">
                  <button class="layui-btn" v-on:click="ViewProducts(index,item.show)">
                    <i v-if="item.show">隐藏商品</i>
                    <i v-else>显示商品</i>
                  </button>
                  <button class="layui-btn layui-btn-normal" v-on:click="InfoSyn(item)">加载投入</button>
                  <button class="layui-btn layui-btn-warm" v-on:click="SynOrder(item)">同步订单</button>
              	</td>
              </tr>
              <tr class="product_box" v-viewer v-if="item.show">
                <td colspan="14" class="product_box_tr" style="border:0;background-color: #FAFAFA;">
                  <div class="product_box">
                    <div class="table-header">
                      <table class="layui-table" style="" v-for="(val,ix) in item.order_datas.items">
                        <tbody class="images">
                          <tr>
                            <td colspan="14" class="product_box_tr" style="border:0;padding:0 !important;margin-top:0;">
                              <div>
                                <table class="layui-table" style="margin: 0;">
                                  <thead>
                                    <tr class="trth">
                                      <th style="width:80px;">图片</th>
                                      <th>id</th>
                                      <th>规格编号</th>
                                      <th>SKU</th>
                                      <th>支出</th>
                                      <th style="width:350px;">名称</th>
                                      <th>规格</th>
                                      <th>数量</th>
                                      <th>价格</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td :class="{'hintBack':!val.isTrue}">
                                        <div class="table_img"><img :src="val.img"></div>
                                      </td>
                                      <td v-text="val.item_id"></td>
                                      <td v-text="val.variation_id"></td>
                                      <td v-text="val.item_sku"></td>
                                      <td v-text="val.pay_money"></td>
                                      <td>
                                        <div class="onlyOneRow" style="width:350px;" v-text="val.item_name"></div>
                                      </td>
                                      <td v-text="val.variation_name"></td>
                                      <td class="redColor" v-text="'x'+val.variation_quantity_purchased"></td>
                                      <td>
                                        <div>
                                          <i v-if="item.country == 'TW'" v-text="'NT'+val.variation_original_price"></i>
                                          <i v-else-if="item.country == 'PH'" v-text="'₱'+val.variation_original_price"></i>
                                          <i v-else-if="item.country == 'VN'" v-text="'₫'+val.variation_original_price"></i>
                                          <i v-else-if="item.country == 'TH'" v-text="'฿'+val.variation_original_price"></i>
                                          <i v-else-if="item.country == 'ID'" v-text="'Rp'+val.variation_original_price"></i>
                                          <i v-else-if="item.country == 'SG'" v-text="'$'+val.variation_original_price"></i>
                                          <i v-else-if="item.country == 'BR'" v-text="'R$'+val.variation_original_price"></i>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </td>
              </tr>
          </tbody>

        </table>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

      </div>

    </div>

    <!-- 分页 -->
    <div class="page-box">
      <div id="pagebox" class="pagebox"></div>
    </div>

    <!--scroll to top-->
    <div class="scroll-top">
      <i class="fa fa-angle-up" aria-hidden="true"></i>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

  </div>
</template>

<script>
  var self, form, layer, laydate, laypage, list_ix, this_ix, product, layerIndex, StockBox;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'Order',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        name: "黑领科技",
        oid: null,
        shop_id: null,
        layerIndex: null,
        loading: false,
        isLoding: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        page_num:20,
        SelectedNum:0,
				country: [],
				current_country: 0,
        country_name:null,
        order_id: null,
        shipment_id:null,
        module_type: 1,
        list: [],
        item: null,
        current_shop: 0,
        shop_list: [],
        current_status: 0,
        status_list: [{
					id: 1,
					en: 'UNPAID',
					cn: '代付款'
				}, {
					id: 2,
					en: 'READY_TO_SHIP',
					cn: '待处理'
				}, {
					id: 3,
					en: 'SHIPPED',
					cn: '运输中'
				}, {
					id: 4,
					en: 'CANCELLED',
					cn: '已取消(未出货)'
				}, {
					id: 4,
					en: 'CANCELLED',
					cn: '已取消(已出货)'
				}, {
					id: 5,
					en: 'COMPLETED',
					cn: '已完成'
				}],
        loglist: [],
        gotop: false,
        isAll: false,
        attach:[],
        number:null,
        proix:null,
        total_amount:0,
        actual_invested:0,
        escrow_amount:0,
        profit:0,
        profit_margin:0
      }
    },
    updated() {
      if (form) {
        form.render()
      }
      self.NumberCheck();
    },
    watch: {
      $route: {
        handler(nv, ov) {
          self.list = [];
          self.current_status = nv.query.te;
          self.get_order_list(true)
        }
      },
      deep: true
    },
    mounted() {
      self = this;
      self.country = country;
      self.SetNavActive("管理",self.$route.name);

      if (localStorage.getItem("ExShopee_id")) {
        self.name = self.name + localStorage.getItem("ExShopee_id")
      }

      if (self.$route.query.te) {
        self.current_status = self.$route.query.te
      }

      scrollTop(); //监听滚动置顶
      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laydate = layui.laydate;
        laypage = layui.laypage;

        //时间控件
        laydate.render({
          elem: '#order_date',
          range: true,
          min: self.formatDate(self.getDateThreeMonthsAgo()),
          trigger: 'click',
          done: function(value, date, endDate) {
            self.page = 1;
            $("#order_date").val(value);
            self.get_order_list()
          }
        });

        //状态选择
        form.on('select(status_selection)', function(data) {
          self.list = [];
          var val = $("select[name=status").val();
          self.current_status = val;
          self.get_order_list()
        });

        form.on('select(country_selection)', function(data) {
        	var val = data.value;
        	self.current_country = val;
        	var country;
        	if (val > 0) {
        		country = self.country[self.current_country-1].en_name;
        	} else {
        		country = null;
        	}
        	self.country_name = country; //获取当前站点
        	self.get_order_list()
        });

        //店铺选择
        form.on('select(shops_selection)', function(data) {
          self.list = [];
          var val = $("select[name=shop").val();
          self.current_shop = val;
          self.get_order_list(true)
        });

        //全选
        form.on('checkbox(cxall)', function(data) {
          var child = $(".cx-box input[type='checkbox']");
          var status = data.elem.checked;
          var num = 0;
          child.each(function(index, item) {
            item.checked = data.elem.checked;
            self.list[index].active = status;
            if(status){
              num++
            }
          });
          form.render('checkbox');
        });

        //单选
        form.on('checkbox(cx)', function(data) {
          let ix = data.elem.dataset.index;
          let status = data.elem.checked;
          self.list[ix].active = status;
          form.render('checkbox');
        });

        //单选
        $("#main-box").on("click", '.cx-box', function(e) {
          var ix = $(this).attr("data-ix");
          if (self.list[ix].active) {
            self.list[ix].active = false;
          } else {
            self.list[ix].active = true;
          }
          form.render('checkbox');
        });

        $(".layui-body").scroll(function() {
          let scrollTop = $(this).scrollTop();
          if(scrollTop > 30){
            $(".FloatingNav").css({top:70+'px'});
          }else{
            $(".FloatingNav").css({top:'auto'});
          }
        })

        form.render();

        self.get_shop_list(); //加载店铺
        self.get_order_list(true); //加载订单
        self.VersionCheck(); //版本检测
      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (data.state) {
          var url;
          let param = new URLSearchParams()
          var list = self.list;
          var arr = {},x=0;
          for(let i in list){
            if(list[i].active == true){
              if (!arr.hasOwnProperty(list[i].shop_id)) {
                arr[list[i].shop_id] = []
              }
              arr[list[i].shop_id].push(list[i].id)
              x++
            }
          }
          if(x<=0){
            self.ToastFun(1, "请先选中需要同步的订单！"); //弹窗提醒
            self.Confirm.state = false;
            return;
          }
          if(x > 50){
            self.ToastFun(1, "单次同步订单数量不能超过50个！"); //弹窗提醒
            self.Confirm.state = false;
            return;
          }
          param.append('datas', JSON.stringify(arr));
          self.Confirm.state = false;
          self.loading = true;
          axios({
            method: 'post',
            url: self.GetServerUrl() + "/reload_orders/",
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {

            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              self.ToastFun(0, "操作成功！"); //弹窗提醒
              self.get_order_list()
            }, false, true);

          }).catch(function(error) {
            self.loading = false;
            console.log(error);
          })

        }
      },
      VersionCheck () {
        axios({
          method: 'post',
          url: self.GetServerUrl() +"/version/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(res) {
          var json = res.data;
          if(json.code == 200){
            if(json.datas.version != localStorage.getItem("ExShopee_Version")){
              localStorage.setItem("ExShopee_Version",json.datas.version);
              window.location.reload(true);
            }
          }
        }).catch(function(error) {
          console.log(error);
        })
      },
      get_shop_list() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_shop_list/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.shop_list = datas.list;
          });

        }).catch(function(error) {
          console.log(error);
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      get_order_list(s) {
        if (s) {
          self.list = []
          self.page = 1;
        }
        if (self.gotop) {
          $('.table-box').animate({
            scrollTop: 0
          }, 0);
          self.gotop = false;
        }

        var t = $("#order_date").val();
        //获取的结束时间自动加一天
        var start_time, end_time;
        if (t) {
          self.getDate(t, function(s, e) {
            start_time = s;
            end_time = e;
          })
        }

        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('status', self.current_status)
        param.append('shop_id', self.current_shop)
        param.append('num', self.page_num)
        if(self.country_name){
          param.append('country', self.country_name)
        }

        // param.append('id', "220510SU73BCPH") //测试

        if (self.order_id) {
          param.append('id', self.order_id)
        }else if(self.$route.query.id){
          param.append('id', self.$route.query.id)
        }
        if (start_time) {
          param.append('start_time', start_time)
        }
        if (end_time) {
          param.append('end_time', end_time)
        }
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/manage_order_list/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var dataList = datas.list;
            var shiplist = datas.shipment_list;
            var item_list = datas.item_list;
            var model_list = datas.model_list;
            var amount = datas.country_amount;

            if(amount){
              var escrow_amount=0,pay_money_all=0,total_amount=0;
              for(let z in amount){
                total_amount += parseFloat(amount[z].total_amount_all_exchange);
                escrow_amount += parseFloat(amount[z].escrow_amount_all_exchange);
                pay_money_all += parseFloat(amount[z].pay_money_all);
              }
              self.total_amount = total_amount.toFixed(2);
              self.actual_invested = pay_money_all.toFixed(2);
              self.escrow_amount = escrow_amount.toFixed(2);
              self.profit = (escrow_amount - pay_money_all).toFixed(2);
              if(pay_money_all){
                self.profit_margin = (self.profit / pay_money_all * 100).toFixed(2)
              }
            }

            if (datas.page) {
              var pageDatas = datas.page;
              for (var item in dataList) {
                var dataobj = JSON.parse(dataList[item].order_datas);
                var productobj = null;
                dataList[item].active = false;  //初始化选中
                dataList[item].total_expend = 0;  //订单总支出

                if (dataList[item].product_info) {
                  productobj = JSON.parse(dataList[item].product_info);
                }
                dataList[item].product_info = productobj;

                //新版兼容
                if(dataobj.package_list && dataobj.package_list.length > 0){
                  if(dataobj.order_status == "PROCESSED"){
                    dataList[item].order_status = "READY_TO_SHIP";
                    dataList[item].tracking_no = dataobj.package_list[0].package_number;
                  }
                  if(dataobj.package_list[0].logistics_status == "LOGISTICS_PICKUP_DONE"){
                    dataList[item].tracking_no = dataobj.package_list[0].package_number;
                  }
                  dataobj.shipping_carrier = dataobj.package_list[0].shipping_carrier;
                }


                //支出RMB转换
                // for(let j in self.country){
                //   if(self.country[j].en_name == dataList[item].country){
                //     dataList[item].cn_credit = (dataobj.escrow_amount / self.country[j].exchange).toFixed(2);
                //   }
                // }

                if(dataobj.escrow_amount_exchange){
                  dataList[item].cn_credit = dataobj.escrow_amount_exchange.toFixed(2);
                }
                if(dataList[item].pay_money){
                  if(dataList[item].cn_credit){
                    dataList[item].profit = (dataList[item].cn_credit - dataList[item].pay_money).toFixed(2); //利润
                    dataList[item].profit_margin = (dataList[item].profit / dataList[item].pay_money * 100).toFixed(2); //利润率
                  }
                }else{
                  dataList[item].pay_money = "待载入"
                }

                //判断是否有图片写入
                var s=1;
                let items = dataobj.items;
                if(dataobj.item_list){
                  items = dataobj.item_list
                }
                // console.log(items)
                for (let i in items) {
                  items[i].isTrue = true;
                  items[i].shipment_number = []

                  if(!items[i].image_info){
                    if (dataList[item].product_info) {
                      let pobj = dataList[item].product_info; //获取图片信息，插入OBJ里面
                      if (pobj[i]) {
                        items[i].img = pobj[i].image; //图片写入
                      } else {
                        items[i].img = "../../../static/images/loading3.gif"; //图片写入
                      }
                    } else {
                      items[i].img = "../../../static/images/loading3.gif"; //图片写入
                    }

                    var itemid = items[i].item_id;
                    let str = items[i].variation_name;
                    let vid = items[i].variation_id;
                    let sku = str.split(",")[0];
                    if(!vid){
                      vid = items[i].item_id;
                    }
                    if (item_list && item_list[itemid]) {

                      if(item_list[itemid][vid]){
                        items[i].img = item_list[itemid][vid];
                      }else{
                        for(let z in item_list[itemid]){
                          items[i].isTrue = false;
                          items[i].img = item_list[itemid][z];
                        }
                      }
                    }
                  }else{
                    items[i].img =  items[i].image_info.image_url; //图片
                    items[i].variation_quantity_purchased = items[i].model_quantity_purchased; //数量
                    items[i].variation_id = items[i].model_id; //变体id
                    items[i].variation_name = items[i].model_name; //规格
                    items[i].variation_original_price = items[i].model_discounted_price; //价格
                    dataobj.items = items;
                  }

                  //支出计算
                  for(let x in model_list){
                    var proid;
                    if(items[i].variation_id == 0){
                      proid = items[i].item_id;
                    }else{
                      proid = items[i].variation_id;
                    }
                    if(model_list[x].model_id == proid){
                      if(model_list[x].price){
                        items[i].pay_money = parseFloat(model_list[x].price);
                      }
                      if(model_list[x].other_price){
                        items[i].pay_money += parseFloat(model_list[x].other_price);
                      }
                      if(items[i].pay_money){
                        dataList[item].total_expend += items[i].pay_money * items[i].variation_quantity_purchased
                      }
                    }
                  }
                  s++
                }
                dataList[item].order_datas = dataobj;

              }
              console.log(dataList);
              self.list = dataList;
              self.count = pageDatas.count; //页数
              self.ShowPage(self, laypage, "get_order_list", 10); //分页
              $('.pagebox').show();
            } else {
              self.list = [];
              self.count = 0; //页数
              $('.pagebox').hide();
            }
          },function(){
            self.actual_invested = 0;
            self.escrow_amount = 0;
            self.profit = 0;
            self.profit_margin = 0;
            self.list = [];
            self.count = 0; //页数
            $('.pagebox').hide();

            //自动换页
            if (self.page > 1) {
              self.page -= 1;
              self.get_order_list();
            }
          });

        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      NumberCheck(){
        let num = 0;
        for(let i in self.list){
          if(self.list[i].isActive){
            num++
          }
        }
        self.SelectedNum = num;
        let scrollTop = $(".layui-body").scrollTop();
        if(scrollTop > 30){
          $(".FloatingNav").css({top:70+'px'});
        }else{
          $(".FloatingNav").css({top:'auto'});
        }
      },
      ViewProducts (ix,state) {
        if(state){
          self.list[ix].show = false;
        }else{
          self.list[ix].show = true;
        }
        self.$forceUpdate();
      },
      InfoSyn (item) {
        let param = new URLSearchParams()
        var datas = [];
        if(item == "all"){
          for(let i in self.list){
            if(self.list[i].active && self.list[i].total_expend){
              datas.push({id:self.list[i].id,pay_money:self.list[i].total_expend});
            }
          }
        }else{
          var oid = item.id;
          var total_expend = item.total_expend;
          if(total_expend){
            datas.push({id:oid,pay_money:total_expend});
          }
        }
        if(datas.length > 0){
          self.loading = true;
          param.append('datas', JSON.stringify(datas));
          axios({
            method: 'post',
            url: self.GetServerUrl() + "/static_order_money/",
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {

            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              self.ToastFun(0, "信息同步成功！"); //弹窗提醒
              self.get_order_list();
            });

          }).catch(function(error) {
            console.log(error);
            self.ToastFun(2, error); //弹窗提醒
          })
        }else{
          self.ToastFun(1, "请填写商品价格！"); //弹窗提醒
        }
      },
      SynOrder (item) {
        self.loading = true;
        let param = new URLSearchParams()
        param.append('id', item.id);
        param.append('shop_id', item.shop_id);
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/reload_order/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.ToastFun(0, "订单同步完成！"); //弹窗提醒
            self.get_order_list();
          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      ConfirmHint(te) {
        self.Confirm.style = te;
        self.Confirm.state = true;
        self.Confirm.txt = "是否确定同步选中订单？"
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .country_select {
    width: 120px;
  }
  .cx-box{
    width: 20px;
  }
  .xblock{
    padding: 0 10px 0 5px;
  }
  .xblock-row{
    margin: 5px 0;
    margin-right: 5px;
  }

  .boxlist {
    margin-top: 15px;
    border: 1px solid #F3F3F3;
  }

  .btn-arr{
    width: 300px;
  }

  .switch {
    font-size: 20px;
    display: table;
    margin: 0 auto;
    cursor: pointer;
  }

  .table_footer_box {
    border: 0;
    padding: 0 !important;
  }

  .table_footer {
    overflow: hidden;
    padding: 5px 0 15px 0;
    border-top: 1px solid #F3F3F3;
  }

  .table_footer li {
    float: left;
    padding-right: 20px;
    padding-left: 20px;
    margin-top: 10px;
    border-right: 1px solid #E3E3E3;
  }

  .table_footer li:last-child {
    padding-right: 0;
    border-right: 0;
  }

  .table_footer li p {
    float: left;
    position: relative;
  }

  .table_footer a {
    color: #666;
    cursor: pointer;
    margin-right: 8px;
  }

  .table_footer a:hover {
    color: #01AAED;
  }

  .trth th {
    background-color: #fdfdfd;
  }

  .execption_img {
    margin-right: 0 !important;
  }

  .fkghint {
    cursor: pointer;
    display: inline-block;
    line-height: 18px;
    height: 18px;
    padding: 0 8px 0 8px;
    margin-bottom: 4px;
    white-space: nowrap;
    background-color: #f2fbf4;
    border: 1px solid #c5edd0;
    border-radius: 1px 10px 10px 1px;
    color: #5c7;
  }

  .addlog {
    cursor: pointer;
  }

  .inputbox {
    overflow: hidden;
    margin-bottom: 10px;
  }

  .inputbox a {
    display: block;
    float: left;
  }

  .inputbox a:first-child {
    max-width: 180px;
    width: calc(100% - 75px) !important;
  }

  .inputbox a input {
    width: calc(100% - 20px);
    padding: 0 10px;
    height: 30px;
    border: 1px solid #E3E3E3;
  }

  .inputbox a:hover {
    color: #333;
  }

  .inputbox a i:hover {
    color: #007DDB;
  }

  .inputbox a i:last-child {
    margin-left: 5px;
  }

  .inputbox a:last-child {
    width: 65px;
    line-height: 32px;
    margin-left: 10px;
  }

  .loglist {
    margin-top: 15px;
  }

  .loglist:first-child {
    margin-top: 0;
  }

  .loglistborder {
    border: 1px solid #e6e6e6;
  }

  .loglistborder td {
    padding: 15px;
    border: 0 !important;
  }

  .loglistborder:first-child {
    border-top: 0;
  }

  .xblock {
    margin-bottom: 0;
  }

  .nav-btn-arr {
    padding: 10px;
    background-color: #f2f2f2;
  }

  .nav-btn-arr ul {
    overflow: hidden;
    position: relative;
    padding-left: 35px;
  }

  .nav-btn-arr ul li {
    float: left;
  }

  .nav-btn-arr .nav-btn {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #E2E2E2;
    background-color: #F1F1F1;
    margin-right: 5px;
    cursor: pointer;
  }

  .nav-btn-arr ul li:hover {
    background-color: #F4F4F4;
  }
</style>



// WEBPACK FOOTER //
// src/components/manage/Order.vue